module.exports = __webpack_public_path__ + "dc8db18ba4774e9180ba34b8f0f60672.pdf";